<template>
    <div class="CommonTable">
        <p v-if="!onlyTable" class="homeComTitle flex_box  align-items_center" :class="[ imgClass ]">
            <span class="flex_1">{{ title }}</span>
            <span v-if="hasHint" class="fs12 co_B0 font_n">{{ hintMsg }}</span>
        </p>
        <section v-if="tableData.body.length > 0">
            <p v-if="mainContent && mainContent === 'isMediaReport'" class="mainContent mt12"
               :html="mainContent">今日，行业敏感舆情的核心报道媒体为<b>{{ tableData.body[0].name }}</b>，负面报道占比为<b>{{ tableData.body[0].percent }}%</b>，需重点关注。</p>
            <table :class="tableName">
                <thead class="thead">
                <tr>
                    <td v-for="item in tableData.head" :key="item.name">{{ item.name }}</td>
                </tr>
                </thead>
                <tbody class="tbody">
                <tr v-for="(item, index) in tableData.body" :key="index">
                    <td v-for="(subItem, subIndex) in tableData.head" :key="subIndex">
                        <p v-if="subItem.key === 'index'">{{ index + 1 }}</p>

                        <p class="flex_box" :class="item.className" v-else-if="subItem.key === 'percent' && hasPercentBar" >
                            <mt-progress class="vert_tb mr8" :value="item.percent" :bar-height="16"></mt-progress>
                            <span class="fs18 flex_1 text_c">{{ item[subItem.key] }}{{ subItem.key === 'percent' ? '%' : '' }}</span>
                        </p>

                        <span v-else :class="{ fs18: subItem.key === 'percent' }">
                            {{ subItem.key === 'indexNumber' ? (index + 1) : item[subItem.key] }}{{ subItem.key === 'percent' ? '%' : '' }}
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>
        </section>
        <img v-else class="noDataImg mt28" src="../../assets/img/company/noData.svg" alt="">
<!--        <div class="text_c co_666 mt12" @click="checkMore">查看更多</div>-->
    </div>
</template>

<script>
export default {
    name: "CommonTable",
    props: {
        title: {
            type: String,
            default: '媒体报道倾向'
        },
        imgClass: {
            type: String,
            default: 'textIcon'
        },
        tableData: {
            type: Object,
            default: function () {
                return {
                    head: [],
                    body: []
                }
            }
        },
        tableName: {
            type: String,
            default: 'table4'
        },
        hasPercentBar: Boolean,
        hintMsg: {
            type: String,
            default: '注：排名不分先后'
        },
        mainContent: {
            type: String,
            default: null
        },
        hasHint: Boolean,
        onlyTable: Boolean,
    },
    methods: {
        checkMore() {
            console.log('checkMore');
        }
    }
}
</script>

<style lang="scss" scoped>
.CommonTable {
    padding: 16px;
    .mt-progress {
        width: 88px;
        height: 16px;
        border-radius: 8px;
        overflow: hidden;
        margin-top: 10px;
    }

    .table4{
        .thead {
            td:nth-of-type(2){
                padding-left: 10px;
            }
            td:nth-of-type(4){
                text-align: left;
                padding-left: 30px;
            }
        }
        td{
            &:nth-of-type(1){
                width: 10%;
            }
            &:nth-of-type(2){
                width: 20%;
                text-align: left;
            }
            &:nth-of-type(3){
                width: 30%;
            }
            &:nth-of-type(4){
                width: 40%;
            }
        }
    }
    .table2 {
        padding-left: 20px;
        .thead {
            td:nth-of-type(2) {
                padding-left: 20px;
            }
        }
        .mt-progress {
            width: calc( 100vw - 3rem );
        }
        td {
            &:nth-of-type(1){
                width: 2rem !important;
                text-align: left;
            }
            &:nth-of-type(2){
                text-align: left;
                width: calc( 100vw - 2rem );
            }
        }
    }
    .tablePercent{
        td{
            &:nth-of-type(1){
                width: 40%;
                text-align: left;
                padding-left: 16px;
            }
            &:nth-of-type(2){
                width: 40%;
                text-align: right;
            }
            &:nth-of-type(3){
                width: 20%;
                text-align: center;
            }
        }
    }

    table{
        width: 100%;
        margin-top: 28px;
        tr{
            width: 100%;
            text-align: center;
        }
        .thead{
            tr{
                color: #333333;
                height: 28px;
                line-height: 28px;
                td{
                    padding-bottom: 4px;
                }
            }
        }
        .tbody{
            tr{
                color: #333333;
                td{
                    height: 36px;
                    line-height: 36px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>